import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, StatusPill, PriorityPill, AtomBadge, EmptyState } from "../components/primitives";

const TABS = ["Pending verification","Tier upgrades","Periodic review","EDD","Beneficial ownership"];

export default function KYCQueue() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("Pending verification");
  useEffect(() => { api.get("/kyc/queue").then(r => setData(r.data)); }, []);
  if (!data) return <div className="p-6 text-[13px] text-ink-muted">Loading queue…</div>;
  const tabData = { "Pending verification": data.pending, "Tier upgrades": data.upgrades, "Periodic review": data.periodic, "EDD": data.edd, "Beneficial ownership": data.bo }[tab];

  return (
    <div>
      <PageHeader title="KYC Queue" subtitle="Onboarding · upgrades · periodic review · EDD · BO refresh" sections={["5.2"]} atom={<AtomBadge model="Atom Neutron" version="v2.0" description="KYC retrieval & verification routing" />} />
      <div className="px-6 border-b border-line bg-bg-surface">
        <div className="flex gap-1 overflow-x-auto">
          {TABS.map(t => (
            <button key={t} onClick={() => setTab(t)} className={`px-3 py-2 text-[12px] border-b-2 -mb-px ${tab===t?'border-amber text-ink font-medium':'border-transparent text-ink-muted'}`}>{t} <span className="text-[10px] text-ink-subtle ml-1">{({ "Pending verification": data.pending.length, "Tier upgrades": data.upgrades.length, "Periodic review": data.periodic.length, "EDD": data.edd.length, "Beneficial ownership": data.bo.length }[t])}</span></button>
          ))}
        </div>
      </div>
      <div className="p-6">
        <Card>
          <table className="dense w-full">
            <thead><tr><th>Customer</th><th>Cust ID</th><th>{tab === "Tier upgrades" ? "Requested" : tab === "Periodic review" ? "Last review" : "Reason"}</th><th>Days waiting</th><th>Assigned officer</th><th>Priority</th><th>Atom Neutron suggestion</th></tr></thead>
            <tbody>
              {tabData.map((r, i) => (
                <tr key={i}>
                  <td className="text-[12px] font-medium">{r.name}</td>
                  <td className="text-[11px] hash-mono">{r.id}</td>
                  <td className="text-[12px]">{tab === "Tier upgrades" ? `${r.current} → ${r.requested}` : tab === "Periodic review" ? r.last_review : r.reason}</td>
                  <td className="text-[12px] tabular">{r.days}</td>
                  <td className="text-[12px]">{r.officer}</td>
                  <td><PriorityPill priority={r.priority} /></td>
                  <td className="text-[11px] text-ink-muted">{tab === "EDD" ? "Suggest: full PEP screening + source-of-funds" : tab === "Beneficial ownership" ? "Suggest: refresh declaration; CAC cross-check" : "Suggest: auto-verify documents · 0.94 confidence"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {tabData.length === 0 && <EmptyState message="No items in this queue." />}
        </Card>
      </div>
    </div>
  );
}
